import { render, staticRenderFns } from "./ChannelTypeChannelEdit.vue?vue&type=template&id=11db10e5&"
import script from "./ChannelTypeChannelEdit.vue?vue&type=script&lang=ts&"
export * from "./ChannelTypeChannelEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelTypeChannelEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelTypeChannelEdit.vue"
export default component.exports